<template>
    <div class="Offre">
      <!-- <Navbar title="Yajobici" /> -->
  
      <div class=" p-0">
        <div class="">
          <div class="main-body">

            <div class="row p-0 m-0">
                <div class="col-lg-3 l-bg-orange-dark"></div>

                <div class="col-lg-9">

                <div class="container mb-5"> <br><br>
                  <router-link to="/" style="color: #f7a51b; font-size: 17px !important;"
                      ><i class="fas fa-arrow-left ms-2"></i>
                      Retournez à l'accueil</router-link
                    >
                  <p class="mt-4" style="font-size: 45px;">Comment supprimer son compte ?</p><br>

                  <div class="list mb-4">
                    <div class="num">
                      <h3>
                        Allez sur la page d'accueil
                      </h3>
                    </div>
                    <div class="num">
                      <h3>
                        Ensuite cliquez sur le boutton "Connexion" situé en haut à droite de la barre de navigation
                      </h3>
                    </div>
                    <div class="num">
                      <h3>Vous serez redirigé sur la page de Connexion
                          (Remplissez le formulaire),
                      </h3>
                    </div>
                    <div class="num">
                      <h3>
                        Une fois connecté, cliquez sur "Mon espace" 
                        en haut à droite de la barre de navigation,
                      </h3>
                    </div>
                    <div class="num">
                      <h3>
                        Cliquez sur le boutton "Mes paramètres" dans la barre de navigation à gauche,
                      </h3>
                    </div>
                    <div class="num">
                      <h3>Enfin, cliquez sur "Supprimer mon compte" et suivez les différentes étapes.</h3>
                    </div>
                  </div>
                  <router-link to="/connexion">
                    <button class="btn" style=" color: white;border-radius: 5px !important; 
                    border: 2px solid #F7A51B !important; background-color: #F7A51B !important;">
                        Commencer le processus
                    </button>
                  </router-link>
                </div>
                    
                </div>
            </div>

            

          </div>
          <!-- end  main body -->
        </div>
        <!-- end  container -->
  
        
  
        
      </div>
      <!-- end  container-fluid -->
    </div>
    <!-- end  div.offre -->
  </template>
  
<script>
  export default {
    name: "DeleteAccount",
    components: {},
  };
</script>
  
<style scoped>

.heading {
  color: #fff;
  text-align: center;
}
.heading h1 {
  margin-bottom: 3rem;
  font-weight: 300;
  position: relative;
}
.heading h1:after {
  content: '';
  height: 2px;
  width: 2rem;
  position: absolute;
  left: 50%;
  bottom: -1rem;
  transform: translateX(-50%);
  background-color: #fff;
}

.container .list .num {
  text-align: justify !important;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: 0.25s;
}
.container .list .num:nth-child(0):before {
  content: '0';
  font-size: 2rem !important;
  font-weight: bold;
  color: #61C7F2;
  width: 2rem;
  transition: 0.25s;
}
.container .list .num:nth-child(1):before {
  content: '1';
  font-size: 3.8rem;
  font-weight: bold;
  color: #61C7F2;
  width: 2rem;
  transition: 0.25s;
}
.container .list .num:nth-child(2):before {
  content: '2';
  font-size: 3.8rem;
  font-weight: bold;
  color: #61C7F2;
  width: 2rem;
  transition: 0.25s;
}
.container .list .num:nth-child(3):before {
  content: '3';
  font-size: 3.8rem;
  font-weight: bold;
  color: #61C7F2;
  width: 2rem;
  transition: 0.25s;
}
.container .list .num:nth-child(4):before {
  content: '4';
  font-size: 3.8rem;
  font-weight: bold;
  color: #61C7F2;
  width: 2rem;
  transition: 0.25s;
}
.container .list .num:nth-child(5):before {
  content: '5';
  font-size: 3.8rem;
  font-weight: bold;
  color: #61C7F2;
  width: 2rem;
  transition: 0.25s;
}
.container .list .num:nth-child(6):before {
  content: '6';
  font-size: 3.8rem;
  font-weight: bold;
  color: #61C7F2;
  width: 2rem;
  transition: 0.25s;
}


.container .list .num h3 {
  position: relative;
  left: -1.5rem;
  color: #3d3d3d;
  font-size: 1.1rem;
  transition: 0.25s;
}
.container .list .num:hover {
  background-color: #ffffff;
  color: #61C7F2 !important;
  cursor: pointer;
  border-radius: 15px !important;
  box-shadow: 4px 4px 8px rgba(0,0,0,0.1);
}
/* .container .list .num:hover:before {
  opacity: 0.2;
} */
.container .list .num:hover h3 {
  left: 1rem;
  color: #61C7F2;
}

.message {
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  margin-top: 2rem;
}

.Offre {
  height: 100%;
  min-height: 100vh;
}
.l-bg-orange-dark {
    background: #61C7F2 !important;
    color: #fff;
}

</style>
  